import { actionType } from "../utils/helpers/generalHelper";
import * as PaymentConstants from "../constants/payment.constant";
import PaymentService from "../services/payment.service";
import ErrorHelper from "../utils/helpers/errorHelper";
import { toast } from "react-hot-toast";

export const makeDocumentPayment = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(PaymentConstants.MAKE_PAYMENT_REQUEST));
    const data = await PaymentService.documentPayment(payload);
    // console.log("data >>> ", data);
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    if (responseData.status === "SUCCESS") {
      dispatch(actionType(PaymentConstants.MAKE_PAYMENT_SUCCESS, responseData));
      window.location.href = `${responseData?.data?.partnerLink}`;
    } else {
      const data = { message: "Network error!.Try again" };
      throw data;
    }
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(PaymentConstants.MAKE_PAYMENT_FAILURE));
    toast.error(message);
  }
};

export const feePayment = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(PaymentConstants.MAKE_PAYMENT_REQUEST));
    const data = await PaymentService.documentPayment(payload);
    console.log("data >>> ", data);
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    if (responseData.status === "SUCCESS") {
      dispatch(actionType(PaymentConstants.MAKE_PAYMENT_SUCCESS, responseData));
      window.location.href = `${responseData?.data?.partnerLink}`;
    } else {
      const data = { message: "Network error!.Try again" };
      throw data;
    }
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(PaymentConstants.MAKE_PAYMENT_FAILURE));
    toast.error(message);
  }
};

export const verifyTransaction =
  (payload, navigateLink) => async (dispatch) => {
    console.log("verifying payment...");

    try {
      dispatch(actionType(PaymentConstants.VERIFY_PAYMENT_REQUEST));
      const data = await PaymentService.verifyPayment(payload);
      console.log("verifyTransaction " + data);
      if (data.status !== 200) {
        throw data;
      }
      const responseData = data.data;
      if (responseData.status === "SUCCESS") {
        dispatch(
          actionType(PaymentConstants.VERIFY_PAYMENT_SUCCESS, responseData)
        );
        navigateLink();
        // window.location.href = `${responseData?.data?.partnerLink}`;
      } else {
        const data = { message: "Network error!.Try again" };
        throw data;
      }
    } catch (error) {
      let message = ErrorHelper.getApiErrorMessage(error);
      dispatch(actionType(PaymentConstants.VERIFY_PAYMENT_FAILURE));
      toast.error(message);
    }
  };

export const fetchCurrencyCodes = () => async (dispatch) => {
  try {
    dispatch(actionType(PaymentConstants.GET_CURRENCY_REQUEST));
    const data = await PaymentService.getCurrencyCodes();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(actionType(PaymentConstants.GET_CURRENCY_SUCCESS, responseData));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(PaymentConstants.GET_CURRENCY_FAILURE));
    toast.error(message);
  }
};
